export default function RoleViewController(
  $scope,
  $stateParams,
  $filter,
  usersService,
  $uibModal,
  RoleService,
  gettextCatalog,
) {
  'ngInject';

  $scope.filteredDataPoints = [];
  $scope.loading = true;
  $scope.dataPointsByPage = [];
  $scope.search = {
    query: '',
  };
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.searchQuery = '';
  $scope.previousSearchQuery = '';

  ///Sorting
  $scope.predicate = 'description';
  $scope.reverse = true;
  var orderBy = $filter('orderBy');

  //Sort filteredDataPoints
  $scope.orderDataPoints = function (predicate1, loading = false) {
    $scope.predicate1 = predicate1;
    $scope.reverse1 = $scope.predicate1 === predicate1 ? !$scope.reverse1 : false;

    angular.forEach($scope.filteredDataPoints, function (datapoint) {
      datapoint[predicate1] = datapoint[predicate1];
    });
    $scope.filteredDataPoints = orderBy($scope.filteredDataPoints, predicate1, $scope.reverse1);
    $scope.displayDataPointsByPage();
    if (!loading) GTM_DatapointListChanged('roleDatapointsOrderChanged');
  };

  //Pagination
  $scope.current = {
    datapointPage: 1,
  };
  $scope.datapointsPerPage = 20;
  $scope.maxSize = 3;

  $scope.allowRoleAssignment = function () {
    return (
      usersService.hasRequiredFeatures(['admin.roles.users']) &&
      ($scope.roleData == null || !$scope.roleData.unassignable)
    );
  };

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredDataPoints.
  $scope.displayDataPointsByPage = function () {
    if ($scope.filteredDataPoints) {
      $scope.totalItems = $scope.filteredDataPoints.length;
      var begin = ($scope.current.datapointPage - 1) * $scope.datapointsPerPage;
      var end = begin + $scope.datapointsPerPage;
      $scope.dataPointsByPage = $scope.filteredDataPoints.slice(begin, end);
    }
  };

  //Calls displayDataPointsByPage(), everytime the the user changes the page.
  $scope.pageChanged = function () {
    $scope.displayDataPointsByPage();
    GTM_DatapointListChanged('roleDatapointsPageChanged');
  };

  //applyFilter() searches the dataPoints[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.previousSearchQuery === $scope.searchQuery) return;
    $scope.filteredDataPoints = $filter('filter')($scope.datapointList, $scope.searchQuery);
    $scope.displayDataPointsByPage();
    $scope.previousSearchQuery = $scope.searchQuery;
    GTM_DatapointListChanged('roleDatapointsFiltered');
  };

  $scope.deleteButtonPressed = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;

    var modalInstance = $uibModal.open({
      animation: true,
      template: require('./delete-modal/_delete.modal.html'),
      controller: 'RoleViewDeleteModalController',
      backdropClass: 'tr-role-delete-dismiss',
      resolve: {
        roleName: function () {
          return $scope.roleData.name;
        },
        roleId: function () {
          return $stateParams.roleId;
        },
      },
      size: 'md',
    });
  };

  $scope.getLeftPermissionPadding = function (permission) {
    if (!permission.path) return 0;

    function countPeriods(input) {
      var result = 0;

      for (var i = 0; i < input.length; i++) {
        if (input[i] == '.') {
          result++;
        }
      }
      return result;
    }

    return countPeriods(permission.path) * 50;
  };

  var refresh = function () {
    RoleService.getRole($stateParams.roleId)
      .then(function (response) {
        $scope.roleData = response.data;

        $scope.$emit('$viewContentLoaded'); //breadcrumbs fix

        return usersService.getDatapoints();
      }, handleError)
      .then(function (response) {
        var visibleDatapoints = response.data;
        $scope.datapointList = [];
        //only show my visible datapoints
        angular.forEach(visibleDatapoints, function (visibleDp) {
          var isDenied = false;
          if ($scope.roleData.dataPointsDenied) {
            for (var i = 0; i < $scope.roleData.dataPointsDenied.length; i++) {
              var deniedDp = $scope.roleData.dataPointsDenied[i];
              if (deniedDp === visibleDp.id) {
                isDenied = true;
                break;
              }
            }
          }
          if (!isDenied) $scope.datapointList.push(visibleDp);
        });
        $scope.filteredDataPoints = $scope.datapointList;
        $scope.orderDataPoints('description', true);
        $scope.displayDataPointsByPage();
        $scope.loading = false;
        GTM_DatapointListChanged('roleDatapointsLoaded');
      }, handleError);
  };
  refresh();

  var handleError = function (error) {
    var errorMsg = gettextCatalog.getString('An error occurred while retrieving role information');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.onLoadErrorText = errorMsg;
    $scope.onLoadErrorFlag = true;
    $scope.loading = false;
  };

  function GTM_DatapointListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.datapointList.length,
        totalFiltered: $scope.filteredDataPoints.length,
        pageNumber: $scope.current.datapointPage,
        sortDirection: $scope.reverse1 ? 'descending' : 'ascending',
      },
    });
  }
}
